import { Link, useRoute, useRouteData } from "@bcm-dev/bcms-vite";
import { UIButton } from "components/ui";
import { SVGAsset } from "res";

import "./styles.css";

export default function ManageAlertsContent(props) {
    const navigate = useRoute();
    let { added = false } = useRouteData().route ?? {};
    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    if(data.added) {
        added = data.added;
    }

    const onCurrentAlerts = evt => navigate("/advancedAlerts/currentAlerts");
    const onAddAlert = evt => navigate("/advancedAlerts/addAlert");

    return (
        <div className="manage-alerts-content back-link-padding">
            <Link to="/advancedAlerts" className="back-link">
                <span>
                    <SVGAsset id="LeftChevronIcon" data-point="Manage_Alerts_Back_Button" />
                    <span data-point="Manage_Alerts_Back_Button_Label">Back</span>
                </span>
            </Link>
            
            <p className="page-subtitle">Manage Alerts</p>

            { added &&
                <div className="confirmation-banner flex-container flex-horizontal">
                    <SVGAsset id="CircleCheckmarkIcon" className="set-width icon checkmark-icon" />
                    <div className="flex-width confirm-text">The alert was successfully added.</div>
                </div> }

            <div className="flex-container flex-horizontal button-container vertical-stack button-container">
                <div className="flex-container flex-vertical set-width">
                    <UIButton className="primary-button" text="Current Alerts" dataPoint="Manage_Alerts_Current_Alerts_Button" onClick={ onCurrentAlerts } />
                    <UIButton className="primary-button" text="Add Alert" dataPoint="Manage_Alerts_Current_Add_Alert" onClick={ onAddAlert } />
                </div>

                <div className="flex-width" />
            </div>
        </div>
    );
}

export const getDefaultPageData = () => ({
 
});

export const getDefaultPageUI = () => ({
  
});